export default __webpack_public_path__ + "static/media/icon_chart.be7655bc.svg";